import { combineReducers } from 'redux';
import {
    UPDATE_NEXT, RESET_NEXT
} from 'signoxe/constants/actionTypes';

import {
  ASSETS_RESOURCE,
  DEVICES_RESOURCE,
  DEVICE_GROUPS_RESOURCE,
  PLAYLISTS_RESOURCE,
  PLAYLISTS_RESOURCE_V2,
} from 'signoxe/api/resources';

const resourcePage = (resource) =>{
	const nextState = (state=null, action) =>{
		if (resource !== action.resource){return state}
		switch (action.type) {
			case UPDATE_NEXT:
				return action.next
			case RESET_NEXT:
				return null
			default:
				return state
		}
	}

	return combineReducers({
		nextState
	})
}

const paginationState = combineReducers({
    assetPage: resourcePage(ASSETS_RESOURCE),
    devicePage: resourcePage(DEVICE_GROUPS_RESOURCE),
    playlistPage: resourcePage(PLAYLISTS_RESOURCE),
	playlistPageV2: resourcePage(PLAYLISTS_RESOURCE_V2)

});

export default paginationState;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/reducers/pageReducer.js